import { memoize } from '../cache/memoize';

export const getIntlDateTimeFormat = memoize(function getIntlDateTimeFormat(...args: ConstructorParameters<typeof Intl.DateTimeFormat>) {
  return new Intl.DateTimeFormat(...args);
});
